export default {
    // 2019-01-20 12:34:24
    // import timeFormat from "@/utils/timeFormat.js";
    formatTime: function(val) {
      if (!val) {
        return "";
      }
      let date = new Date(val);
      var month = zeroFill(date.getMonth() + 1); 
      var day = zeroFill(date.getDate()); 
      var hour = zeroFill(date.getHours()); 
      var minutes = zeroFill(date.getMinutes()); 
      var seconds = zeroFill(date.getSeconds()); 
  
      var curTime =
        date.getFullYear() + "-" + month + "-" + day + " " + hour + ":" + minutes + ":" +seconds;
      return curTime;
      function zeroFill(i) {
        if (i >= 0 && i <= 9) {
          return "0" + i;
        } else {
          return i;
        }
      }
    },
  
    // 2019-01-20 08 
    hoursTime: function(val) {
      if (!val) {
        return "";
      }
      let date = new Date(val);
      var month = zeroFill(date.getMonth() + 1); 
      var day = zeroFill(date.getDate()); 
      var hour = zeroFill(date.getHours()); 
  
      var curTime =
        date.getFullYear() + "-" + month + "-" + day + " " + hour + ":00:00";
      return curTime;
      function zeroFill(i) {
        if (i >= 0 && i <= 9) {
          return "0" + i;
        } else {
          return i;
        }
      }
    },
    // 2019-01-20 08:00 
    minutesTime: function(val) {
      if (!val) {
        return "";
      }
      let date = new Date(val);
      var month = zeroFill(date.getMonth() + 1); 
      var day = zeroFill(date.getDate()); 
      var hour = zeroFill(date.getHours()); 
      var minutes = zeroFill(date.getMinutes()); 
      var curTime =
        date.getFullYear() + "-" + month + "-" + day + " " + hour + ":"+minutes;
      return curTime;
      function zeroFill(i) {
        if (i >= 0 && i <= 9) {
          return "0" + i;
        } else {
          return i;
        }
      }
    },
    // 2019-01-20
    currentTime: function(val) {
      if (!val) {
        return "";
      }
      var date = new Date(val);
      var month = zeroFill(date.getMonth() + 1); 
      var day = zeroFill(date.getDate()); 
  
      var curTime = date.getFullYear() + "-" + month + "-" + day;
      return curTime;
      function zeroFill(i) {
        if (i >= 0 && i <= 9) {
          return "0" + i;
        } else {
          return i;
        }
      }
    },
    // 18:00
    minuteTime: function(val) {
      if (!val) {
        return "";
      }
      let date = new Date(val);
      var hours = zeroFill(date.getHours()); 
      var minutes = zeroFill(date.getMinutes()); 
  
      var curTime = hours + ":" + minutes;
      return curTime;
      function zeroFill(i) {
        if (i >= 0 && i <= 9) {
          return "0" + i;
        } else {
          return i;
        }
      }
    },
    //  formatFloat(1.2+1.2,2)   formatFloat(1.2*1.2,2) 
    formatFloat:function(f, digit){
       var m = Math.pow(10, digit);
       return Math.round(f * m, 10) / m;
     }
  };
  